import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

/**
 * Hook to start subscription billing (create NMI subscription)
 *
 * Called by organization owners when they have an admin-assigned plan
 * and want to start paying. Requires a payment method to be set up first.
 */
export const useStartSubscription = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => subscriptionService.startSubscription(),
    onSuccess: () => {
      // Invalidate subscription query to refresh the data
      queryClient.invalidateQueries({ queryKey: ['organizationSubscription'] });
      toast.success(tActionMessages.subscriptionStartedSuccessfully);
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message || tActionMessages.failedToStartSubscription,
      );
    },
  });
};
